import React from 'react';
import ABSFormModal from '../ABSFormModal';
import { formatPayload } from '../ABSFormModal/util';
import { IControls } from '../ABSForm';
import ABSFormModalContainerDataHelper from './ABSFormModalContainerDataHelper';
import authService from '../../abs/services/auth/authService';
import RouteConfig from '../../abs/config/routeConfig';

export interface IABSFormModalContainerProps {
  controls: IControls[];
  title: string;
  destroyOnClose?: boolean;
  width?: number;
  payload?: any;
  afterDispatch?: (response: any, values: any) => any;
}

export interface IABSFormModalContainerState { }

class ABSFormModalContainer extends React.Component<
  IABSFormModalContainerProps,
  IABSFormModalContainerState
  > {
  static defaultProps = {
    destroyOnClose: true,
    width: 800
  };

  sendModal;

  formatSendInternalMessage = (values: any) => {
    const { payload } = this.props;
    return formatPayload({ ...values, ...payload });
  };

  openModal() {
    const isLogin = authService.checkIsLogin();
    if (isLogin) {
      this.sendModal.getWrappedInstance().showModal();
      return;
    }
    location.href = RouteConfig.login + '?return_url=' + encodeURIComponent(window.location.href);
  }

  render() {
    const { children, controls, title, destroyOnClose, width, afterDispatch } = this.props;
    return (
      <ABSFormModal
        controls={ABSFormModalContainerDataHelper.formatControls(controls)}
        actionType="account/submitInternalMessage"
        title={title}
        okText="发送"
        width={width}
        ref={view => (this.sendModal = view)}
        beforeSend={this.formatSendInternalMessage}
        destroyOnClose={destroyOnClose}
        afterDispatch={afterDispatch}
        labelWidth={70}
      >
        {children}
      </ABSFormModal>
    );
  }
}

export default ABSFormModalContainer;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSFormModalContainer/index.tsx